module.exports = __webpack_public_path__ + "static/media/Header 3.9f403465.svg";